module.exports = __webpack_public_path__ + "img/logo2.2d62740f.png";